import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../adminportal.css";
import { dashboarddata } from "../../../../../services/AdminService";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    LineChart,
    Line,
    Legend,
} from "recharts";
import { FaUsers } from "react-icons/fa";

const CHART_COLORS = ["#009efd", "#2af598", "#f39c12", "#f1416c", "#9be9fd"];



const roleLabelMap = {
    1: "Admin",
    2: "Owner",
    3: "Top",
    4: "Medium",
    5: "Low",
};

const TotalUserDashboard = () => {
    const [loading, setLoading] = useState(false);
    const [timeFilter, setTimeFilter] = useState("all");

    const [data, setData] = useState({
        totalUsers: 0,
        dailyActiveUsers: 0,
        weeklyActiveUsers: 0,
        monthlyActiveUsers: 0,
        recentusers: [],
        plandistribution: [
            { plan_id: 1, plan_name: "Plan A", user_count: 0 },
            { plan_id: 2, plan_name: "Plan B", user_count: 0 },
        ],
        roleDistribution: [
            { role_id: "Admin", user_count: 0 },
            { role_id: "User", user_count: 0 },
        ],
    });

    useEffect(() => {
        setLoading(true);
        dashboarddata({ timePeriod: timeFilter })
            .then((response) => {
                const apiData = response.data;

                setData({
                    totalUsers: Number(apiData.total_users),
                    roleDistribution: apiData.role_distribution.map((role) => ({
                        role_id: roleLabelMap[role.role_id] || role.role_id, // Map role_id to labels
                        TotalUser: Number(role.user_count)   // Ensure user_count is a number
                    })),
                    plandistribution: apiData.plan_distribution.map((plan) => ({
                        plan_id: plan.plan_id,
                        plan_name: plan.plan_name,
                        user: plan.user_count 
                    })),
                    recentusers: apiData.recent_users.map((users) => ({
                        id: users.id,
                        first_name: users.first_name,
                        last_name: users.last_name,
                        company_name: users.company_name,
                        email: users.email,
                        mobile: users.mobile,
                        created_at: users.created_at,
                    })),
                    dailyActiveUsers: Number(apiData.daily_active_users),
                    weeklyActiveUsers: Number(apiData.weekly_active_users),
                    monthlyActiveUsers: Number(apiData.monthly_active_users),
                });

                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching dashboard data:", error);
                setLoading(false);
            });
    }, [timeFilter]);


    const {
        totalUsers,
        plandistribution,
        roleDistribution,
        recentusers,
        dailyActiveUsers,
        weeklyActiveUsers,
        monthlyActiveUsers,
    } = data;

    return (
        <div>
            {loading && (
                <div className="page-loading">
                    <img src="/images/loader.gif" alt="loader" />
                </div>
            )}
            
            {/* Users Section */}
            <section className="mb-3">
                <h3 className="admin-section-heading">Users Overview</h3>
                <Row xs={1} sm={2} md={4} className="g-4">
                    <StatCard 
                        title="Total Users" 
                        value={totalUsers} 
                        icon={<FaUsers />} 
                        accentClass="admin-accent-blue" 
                    />
                    {plandistribution.map((plan, idx) => {
                        const accents = ["admin-accent-green", "admin-accent-orange", "admin-accent-purple", "admin-accent-blue"];
                        return (
                            <StatCard
                                key={plan.plan_id}
                                title={plan.plan_name}
                                value={plan.user}
                                icon={<FaUsers />}
                                accentClass={accents[idx % accents.length]}
                            />
                        );
                    })}
                </Row>
            </section>

            {/* Analytics Section */}
            <section className="mb-3">
                <h3 className="admin-section-heading">Analytics</h3>
                <Row xs={1} lg={2} className="g-4">
                    <Col>
                        <div className="admin-panel" style={{ height: '400px' }}>
                            <h4 className="admin-section-heading text-center p-3">Role Distribution</h4>
                            <ResponsiveContainer width="100%" height="80%">
                                <BarChart data={roleDistribution}>
                                    <XAxis dataKey="role_id" stroke="#ffffffff" /> 
                                    <YAxis stroke="#ffffffff" />
                                    <Tooltip 
                                        contentStyle={{ backgroundColor: '#1e1e2d', border: '1px solid #2b2b40', color: '#ffffffff', borderRadius: '8px' }}
                                        itemStyle={{ color: '#fff' }}
                                        cursor={{ fill: 'rgba(255,255,255,0.05)' }}
                                    />
                                    <Bar dataKey="TotalUser" fill="#009efd" barSize={40} radius={[6, 6, 0, 0]} /> 
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </Col>
                    {/* <Col>
                        <div className="admin-panel" style={{ height: '400px' }}>
                            <h4 className="admin-section-heading text-center p-3">Plan Distribution</h4>
                            <ResponsiveContainer width="100%" height="80%">
                                <PieChart>
                                    <Pie
                                        data={plandistribution}
                                        dataKey="user"
                                        nameKey="plan_name"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius="80%"
                                        innerRadius="60%"
                                        paddingAngle={2}
                                        label={false}
                                    >
                                        {plandistribution.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />
                                        ))}
                                    </Pie>
                                    <Tooltip 
                                        contentStyle={{ backgroundColor: '#1e1e2d', border: '1px solid #2b2b40', color: '#ffffffff', borderRadius: '8px' }}
                                        itemStyle={{ color: '#fff' }}
                                    />
                                    <Legend verticalAlign="bottom" height={36}/>
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </Col> */}
                </Row>
            </section>

            {/* Recent Users Table */}
            <section className="mb-3">
                <h3 className="admin-section-heading">Recent Registrations</h3>
                <div className="admin-panel overflow-hidden">
                    <div className="admin-table-wrapper">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Company Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Create Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recentusers.map((users) => (
                                    <tr key={users.id}>
                                        <td>{users.first_name}</td>
                                        <td>{users.last_name}</td>
                                        <td>{users.company_name}</td>
                                        <td>{users.email}</td>
                                        <td>{users.mobile || 'N/A'}</td>
                                        <td>
                                            {new Date(users.created_at).toLocaleString("en-GB", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                minute: "2-digit",
                                                hour: "2-digit",
                                                hour12: true,
                                            })}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Active Users Section */}
            <section>
                <h3 className="admin-section-heading">Active Users Overview</h3>
                <Row xs={1} sm={2} md={3} className="g-4">
                    <StatCard title="Daily Active" value={dailyActiveUsers} icon={<FaUsers />} accentClass="admin-accent-green" />
                    <StatCard title="Weekly Active" value={weeklyActiveUsers} icon={<FaUsers />} accentClass="admin-accent-purple" />
                    <StatCard title="Monthly Active" value={monthlyActiveUsers} icon={<FaUsers />} accentClass="admin-accent-orange" />
                </Row>
            </section>
        </div>
    );
};

// StatCard Component - Dark UI
const StatCard = ({ title, value = 0, icon, accentClass }) => (
    <Col>
        <div className="admin-stat-card">
            <div className={`admin-stat-card-title ${accentClass}`}>
                <div className="d-flex justify-content-between align-items-center">
                    <span>{title}</span>
                    <div className="admin-stat-icon-wrapper">
                        {React.cloneElement(icon, { size: 22 })}
                    </div>
                </div>
            </div>
            <div className="admin-stat-card-value">
                {Number(value || 0).toLocaleString()}
            </div>
        </div>
    </Col>
);

export default TotalUserDashboard;